export default "__VITE_ASSET__BxB7z3bq__"